webpackJsonp([21158907686683],{

/***/ 1570:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/it/bachelor/","langKey":"it"}}

/***/ })

});


// WEBPACK FOOTER //
// path---it-bachelor-e848f1d5d4eaffc850f0.js